import { useLocale } from 'next-intl';

import { DEFAULT_LOCALE, type Locale } from './config';

/** BCP 47 tags for `Intl` / `toLocaleDateString` calls. */
const INTL_LOCALES: Record<Locale, string> = {
  en: 'en-US',
  'zh-CN': 'zh-CN',
  'zh-TW': 'zh-TW',
};

export function getIntlLocale(locale: Locale): string {
  return INTL_LOCALES[locale] ?? INTL_LOCALES[DEFAULT_LOCALE];
}

/** BCP 47 tag for the active app locale, for `Intl` APIs. */
export function useIntlLocale(): string {
  return getIntlLocale(useLocale() as Locale);
}
